import { render, staticRenderFns } from "./EpicOption.vue?vue&type=template&id=5f7a690c&scoped=true&"
import script from "./EpicOption.vue?vue&type=script&lang=ts&"
export * from "./EpicOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7a690c",
  null
  
)

export default component.exports